import {AppRegistry} from 'react-native';
//-----------------------------------------------------------------------------
// https://github.com/oblador/react-native-vector-icons#web-setup
// Use the prebuilt version of RNVI located in the dist folder
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Icon from 'react-native-vector-icons/dist/FontAwesome';
import MaterialIcon from 'react-native-vector-icons/dist/MaterialIcons';
import MaterialCommunityIcon from 'react-native-vector-icons/dist/MaterialCommunityIcons';
// Generate the required CSS
import iconFont from 'react-native-vector-icons/Fonts/FontAwesome.ttf';
import materialFont from 'react-native-vector-icons/Fonts/MaterialIcons.ttf';
import materialCommunityFont from 'react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf';

import 'react-native-reanimated'; // required to be first import for vision-camera-code-scanner to function

import App from './App';
import {name as appName} from './app.json';
const iconFontStyles = `@font-face {
    src: url(${iconFont});
    font-family: FontAwesome;
  }
  @font-face {
    src: url(${materialCommunityFont});
    font-family: MaterialCommunityIcons;
  }
  @font-face {
    src: url(${materialFont});
    font-family: MaterialIcons;
  }`;

// Create a stylesheet
const style = document.createElement('style');
style.type = 'text/css';

// Append the iconFontStyles to the stylesheet
if (style.styleSheet) {
  style.styleSheet.cssText = iconFontStyles;
} else {
  style.appendChild(document.createTextNode(iconFontStyles));
}

// Inject the stylesheet into the document head
document.head.appendChild(style);
//-----------------------------------------------------------------------------

AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});
